import React, { Component } from 'react';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

class Collapse extends Component {
    
    render() {
        const { classes } = this.props;
        return (
            <div className="preguntas">
                <Grid container>
                    <Grid item xs={12} className={classes.grid + " description-title"}>
                        Preguntas frecuentes
                        </Grid>
                    <div className={classes.root + " preguntas-collapse"} >
                        <ExpansionPanel className="elevation">
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                                <Typography className="heading">¿Qué requisitos debo cumplir?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="collapse">
                                <Typography>
                                    Nacionalidad: argentino o extranjero con residencia permanente en el país. Edad: 18 años al momento del alta, con cuenta activa en otro banco del sistema financiero argentino.
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel className="elevation">
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="heading">¿Cómo es el proceso?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="collapse">
                                <Typography>
                                    Una vez que simulaste para saber tu tasa podrás acceder a tu nuevo plazo fijo de Banco Hipotecario S.A.:<br />
                                    1.- Completa tus datos y el CBU/Alias CBU de la cuenta de origen de los fondos donde tenes el dinero depositado.<br />
                                    2.- Da el conforme a la operación.<br />
                                    3.- Ingresa a tu banco y acepta la transferencia para la constitución de tu nuevo plazo fijo en Banco Hipotecario S.A.<br />
                                    4.- Recibirás un mail confirmando los datos de la operación.<br />
                                    5.- Al vencimiento del plazo fijo se acreditará en la cuenta de origen el capital más los intereses generados por la inversión.<br />
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel className="elevation">
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="heading">¿Tengo que tener una cuenta en Banco Hipotecario?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="collapse">
                                <Typography>
                                    No es necesario que poseas una cuenta en Banco Hipotecario S.A. Deberás tener una cuenta activa en otro banco con home banking habilitado para aprobar la operación.
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel className="elevation">
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography className="heading">¿Tiene costo la operatoria?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="collapse">
                                <Typography>
                                    No, toda la operatoria es gratuita.
                                 </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>
                </Grid>
            </div>

        );
    }
}

//THEME
const styles = theme => ({
    root: {
        width: '100%',
    },
});

export default withStyles(styles)(Collapse);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/Collapse.js